import React from 'react';
import {Button, Grid, Icon, Loader, Popup, Table} from 'semantic-ui-react';
import moment from 'moment';
import {FiltersOnStyle, HeaderCursor} from '../Professor/ProfessorInputGrades/css';
import {Redirect} from 'react-router';
import {ExportReactCSV} from '../util/ExportCSV';
import SearchTableData from '../util/SearchTableData';
import PaginationFront from "../util/PaginationFront";
import ReactExport from 'react-data-export';
import { sanitizeExcelDataSet } from '../util/sanitizeExcel';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class DataTableSS extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showStudentInfo: false,
            student: null,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            results: []
        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
    }


    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.props.data;
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    render() {
        const { data, excelData } = this.props;

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 150 } },
                    { title: 'Ime oce', width: { wpx: 150 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 300 } },
                    { title: 'Studijski program', width: { wpx: 250 } },
                    { title: 'Nastavni plan', width: { wpx: 150 } },
                    { title: 'Broj diplome', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Datum diplomiranja', width: { wpx: 200 } },
                    { title: 'Zvanje', width: { wpx: 400 } },
                ],
                data: excelData,
            }
        ];

        // const headersForExport = [
        //     { label: 'Prezime', key: 'lastName' },
        //     { label: 'Ime', key: 'firstName' },
        //     { label: 'Ime oca', key: 'fatherName' },
        //     { label: 'Index', key: 'indexNumber' },
        //     { label: 'Broj diplome', key: 'documentNumber' },
        //     { label: 'Datum diplomiranja', key: 'date' },
        //     { label: 'Odsjek', key: 'departmentsSPOU[0].organizationalUnitName' },
        //     { label: 'Studijski program', key: 'studyProgramBasicName' },
        //     { label: 'Plan i program', key: 'studyProgramName' },
        //     { label: 'Zvanje', key: 'title' },
        // ];
        // const dataForExport = data.map((el => ({
        //     Prezime: el.lastName, Ime: el.firstName, Ime_oca: el.fatherName, Index: el.index, Broj_diplome: el.documentNumber, Datum_diplomiranja: moment(el.dateOfGraduation).format('D. M. YYYY.'), Zvanje: el.title, Smjer: el.studyProgramName, Odsjek: el.departments[0].name
        // })));
        if (this.state.showStudentInfo === true) {
            return <Redirect push to={{ pathname: '/filtriranje-studenata/informacije-o-studentu', state: { student: this.state.student } }} />;
        }
        const dataTable =
            (
                <div>
                <Button
                    floated="right"
                    color="blue"
                    basic="true"
                    size="small"
                    style={FiltersOnStyle}
                    onClick={() => this.props.changeWizardStep('prev')}
                >Nazad na filtere </Button>
                <br />
                    {this.props.loader && <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /><br /></div>}
                    {currentPosts.length ?
                    <Table selectable celled>
                    <Table.Header >
                        <Table.Row>
                            <Table.HeaderCell colSpan={16} >
                                <Grid columns={2} stackable>

                                    <Grid.Column width={14}>
                                        <SearchTableData profMozilla data={this.props.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'indexNumber', 'title', 'fatherName']} />
                                    </Grid.Column>
                                    <Grid.Column width={2} textAlign={'center'}>
                                        <ExcelFile filename="Spisak diplomiranih studenata" element={<Popup
                                            trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                <Button.Content visible>
                                                    Excel
                                                </Button.Content>
                                            </Button>}
                                            content="Preuzmi spisak u Excel-u"
                                            hideOnScroll
                                            position="top center"
                                        />}>
                                            <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Studenti" />
                                        </ExcelFile>
                                    </Grid.Column>
                                </Grid>
                            </Table.HeaderCell>
                        </Table.Row>
                        {/*<Table.Row>*/}
                        {/*    <Table.HeaderCell colSpan={16} >*/}
                        {/*        <span> {data && <ExportReactCSV color="green" csvData={data} headers={headersForExport} floated="right" fileName="Spisak diplomiranih studenata" />}*/}
                        {/*            <SearchTableData data={this.props.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'indexNumber', 'title', 'fatherName']} />*/}
                        {/*        </span>*/}
                        {/*    </Table.HeaderCell>*/}
                        {/*</Table.Row>*/}
                        <Table.Row>
                            <Table.HeaderCell width={1}>
                                R. br.
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>Prezime (ime oca) i ime</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>Odsjek</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2} >Studijski program</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>Broj diplome</Table.HeaderCell>
                            <Table.HeaderCell width={4}>Index</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2} >Datum diplomiranja</Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>Zvanje</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body collapsing> {currentPosts.map((row, index) => (
                        (<Popup
                            trigger={<Table.Row
                                key={index}
                                style={HeaderCursor}
                                onClick={() => {
                                    this.setState({ student: row, showStudentInfo: true });
                                    localStorage.setItem('student', JSON.stringify(row));
                                }}
                            >
                                <Table.Cell verticalAlign="middle" collapsing>
                                    {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.

                                </Table.Cell>
                                <Table.Cell colSpan={3}>{row.locked ? <span style={{ float: 'right' }}> <Icon name="lock" color="blue" /></span> : null} {row.lastName} ({row.fatherName}) {row.firstName} </Table.Cell>
                                <Table.Cell colSpan={2}>{row.departmentsSPOU.map(e => <div>{e.organizationalUnitName} <br /></div>)}</Table.Cell>
                                <Table.Cell colSpan={2} ><strong>{row.studyProgramBasicName}</strong> | {row.studyProgramName}</Table.Cell>
                                <Table.Cell colSpan={2}>{row.documentNumber}</Table.Cell>
                                <Table.Cell width={4}>{row.indexNumber}</Table.Cell>
                                <Table.Cell colSpan={2}>{row.dateOfGraduation === null ? null : moment(row.dateOfGraduation).format('D. M. YYYY.')}</Table.Cell>
                                <Table.Cell colSpan={3}>{row.title}</Table.Cell>
                            </Table.Row>}
                            content="Prikaz informacija o studentu"
                            hideOnScroll
                            position="left center"
                        />)))}
                    </Table.Body>
                </Table>
                        : !this.props.loader ? 'Nema podataka o diplomiranim/zaključanim studentima' : null
                    }

                <br />

                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}


            </div>);

        return (

            <div>
                {dataTable}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DegreeDocumentPrint/DataTableSS.js